require('./InvestmentFundView.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const apiURLBuilder = require('core/apiURLBuilder')
const comlexity_icon = require('../../assets/images/complexity_icon.svg');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { fetched: fundFetchRequested } = require('../../actions/funds');
const { closed: glossaryClosed, opened: glossaryOpened } = require('actions/glossary');
const MyFundInfo = require('../MyFundInfo/MyFundInfo');
const MyFundsNavigator = require('../MyFundsNavigator/MyFundsNavigator');
const {
    selectFund,
} = require('../../selectors/fundsSelectors');
const Documentation = require('../../containers/Documentation');
const FundBox = require('../FundBox');
const Glossary = require('components/commons/Glossary/Glossary');
const WizardError = require('components/commons/wizardError/wizardError');
const SelectedTab = require('../../containers/SelectedTab');
const TabSelector = require('../../containers/TabSelector');
const {
    DFI_DOCUMENT_TYPE,
    SEMIANNUAL_DOCUMENT_TYPE,
    PROSPECTUS,
    ANNUAL_DOCUMENT
} = require('../../constants');
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { showMemories } = require('commonsUtilities/showMemoriesHelper');

// @actions
const { searchSpecificIsin: searchDataWithIsin } = require('actions/brokerProductAdvancedSearch');

// Utilities
const { getUrlDocument } = require("utilities/filesHelper");
const { getCountryFromISIN } =  require('utilities/stringHelper');

class InvestmentFundsView extends React.Component {
    constructor(props) {
        super(props);

        this.breadcrumbConfig = this.breadcrumbConfig.bind(this);
        this.getDocumentsFunds = this.getDocumentsFunds.bind(this);
        this.getSubcategory = this.getSubcategory.bind(this);
    }

    componentDidMount() {
        const { fetchFund, fund, match: { params: { id, idType } }, originCountry, isPublicUser, searchData, } = this.props;
        if (!fund) {
            fetchFund({ id, idType, originCountry, isPublicUser });
            searchData(id);
        }
        window.scrollTo(0, 0);
    }


    componentDidUpdate(prevProps, prevState) {
        const { fetchFund, match: { params: { id, idType } }, originCountry , isPublicUser} = this.props;
        if(this.props.match.params.id !== prevProps.match.params.id) {
            fetchFund({ id, idType, originCountry, isPublicUser})
        }
    }

    breadcrumbConfig() {
        const { fund, contextUriFundsLandingView } = this.props;
        const config = [{ text: formatText('fundsSubCategory-breadcrumb'), url: contextUriFundsLandingView}];
        if (fund) { config.push({ text: fund.name, url: '' }) }
        return config;
    }

    getDocumentsFunds(fund) {
        let ArrayDocuments = [];
        const { originCountry, immFeatureFlags } = this.props;
        const showPurchaseAnnualReport = immFeatureFlags.get('wealth_funds_show_purchase_annual_report_document');
        const showPurchaseProspectusReport = immFeatureFlags.get('wealth_funds_show_purchase_prospectus_document');
        const showProspectusDocumentOnNationalFunds = immFeatureFlags.get('wealth_funds_show_prospectus_document_national_funds');
        const showProspectusDocumentOnInternationalFunds = immFeatureFlags.get('wealth_funds_show_prospectus_document_international_funds');
        const showPrecontractualDocumentOnNationalFunds = immFeatureFlags.get('wealth_funds_show_precontractual_document_national_funds');
        const isNationalFund = !!fund && fund.isin && getCountryFromISIN(fund.isin).toLowerCase() === 'es'

        let showProspectus;
        if (isNationalFund) {
            showProspectus = showPurchaseProspectusReport || showProspectusDocumentOnNationalFunds;
        } else {
            showProspectus = showPurchaseProspectusReport || showProspectusDocumentOnInternationalFunds;
        }

        const showSFDR = isNationalFund && showPrecontractualDocumentOnNationalFunds;

        if (fund !== undefined) {
            try {
                ArrayDocuments.push({
                        titlePDF: 'funds-dfiDocument',
                        link: apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: fund.isin, documentType: DFI_DOCUMENT_TYPE, originCountry: originCountry})
                });

                ArrayDocuments.push({
                        titlePDF: 'funds-semestralDocument',
                        link: apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: fund.isin, documentType: SEMIANNUAL_DOCUMENT_TYPE, originCountry: originCountry})
                });

                if (showMemories(originCountry, fund.isin)) {
                    ArrayDocuments.push({
                        titlePDF: 'funds-memory',
                        link: `${getPublicSiteUrl(false)}${this.props.memoriesURL.trim()}${fund.isin}.pdf`
                    })
                }

                if (showProspectus) {
                    ArrayDocuments.push({
                        titlePDF: 'funds-prospectus',
                        link: getUrlDocument(fund.isin, PROSPECTUS, originCountry)
                    });
                }

                if(showPurchaseAnnualReport){
                    ArrayDocuments.push({
                        titlePDF: 'funds-annual_economic_report',
                        link: getUrlDocument(fund.isin, ANNUAL_DOCUMENT, originCountry)
                    });
                }

                if(showSFDR) {
                    ArrayDocuments.push({
                        titlePDF: 'funds-SFDR',
                        link: getUrlDocument(fund.isin, 'SFDR', originCountry)
                    });
                }
            } catch (err) {
                console.error("Could not get documents: "+err);
            }
        }

        return ArrayDocuments;
    }

    getSubcategory(id, subCategories) {
        const subCategoryName = id && subCategories ? subCategories.filter( category => category.id === id.toString() ) : null;

        if (subCategoryName && subCategoryName[0]) {
            const identifier = subCategoryName[0].id;
            return formatText(`fundsSubCategory-key${identifier}`)
        }

        return null;
    }

    buildErrorState() {
        const mainButton = {
            label: formatText('broker-errorGoToMyWallet'),
            url: '/myprofile/broker'
        }
        const errorMessage = formatText('broker-errorPrimaryMessage');
        return(
            <div className="investment-fund-view__error-state">
                <WizardError
                    errorMessage={formatText('broker-errorTitle')}
                    mainButton={mainButton}
                    customClassName="broker-errors-view__body"
                >
                    <div>
                        <div className="broker-errors-view__primary-message">
                            {errorMessage}
                        </div>
                        <div>
                            <FormattedText
                                value="broker-errorSecondaryMessage"
                                injectedStrings={[formatText('emails-investments')]}
                            />
                        </div>
                    </div>
                </WizardError>
            </div>
        )
    }

    buldSuccessState(){
        const {
            fund,
            match,
            UserFundBox,
            onlyOneFundWithSameIsin,
            location,
            catalogueDetails,
            immFeatureFlags,
        } = this.props;
        return (
            <section>
                <div className="grid-view__body">
                    <div className="container">
                        <div className="row broker__header">
                            <div className="col-md-8 col-xs-12 header__info">
                                {
                                    fund && catalogueDetails &&
                                    <FundBox immFeatureFlags={immFeatureFlags} fund={fund} catalogueDetails={catalogueDetails} />
                                }
                                {
                                    !fund && catalogueDetails &&
                                    <LoadingSection />
                                }
                            </div>
                            <div className="col-md-4 col-xs-12 header__purse">
                                <UserFundBox  immFeatureFlags={immFeatureFlags} fund={fund} match={match} location={location} onlyOneFundWithSameIsin={onlyOneFundWithSameIsin}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container wrapper--tabs">
                    <div className="wrapper--tabs">
                        {
                            fund &&
                            <TabSelector fund={fund} />

                        }
                        {
                            fund &&
                            <SelectedTab fund={fund} catalogueDetails={catalogueDetails}/>
                        }
                        {
                            fund &&
                            <Documentation fund={this.getDocumentsFunds(fund)} />
                        }
                        {
                            !fund &&
                            <LoadingSection />
                        }
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const {
            AssetsNavigator,
            fund,
            match,
            assetsCategory,
            subCategories,
            minimumDetails,
            UserFundBox,
            onlyOneFundWithSameIsin,
            location,
            catalogueDetails,
            loading,
            error,
        } = this.props;

        if (fund !== undefined && fund.custom) {
            fund.subCategory = this.getSubcategory(fund.custom.customCategoryId, subCategories);
            fund.minimumDetails = minimumDetails && minimumDetails[0];
            fund.category = assetsCategory;
        }

        let complexity = false;
        if (!!catalogueDetails) {
            catalogueDetails.complexity === 'SI' ?
                complexity = true : complexity = false;
        }
        const content = !loading && error ? this.buildErrorState(): this.buldSuccessState();
        const coverSize = !loading && error ? 'medium' : 'large'
        return (
            <div className="investment-fund-view">
                <Glossary />
                <div className="container__fluid account-movements--header-identifier">
                    {/* TODO: change section. */}
                    <div className="wrapper__header--funds row">
                        <OKCover size={coverSize} section="broker" customClass="col-xs-12">
                            <div className="col-md-8 col-xs-12 investment-fund-view__title">
                                <OKHeaderSubPage
                                    breadcrumbConfig={this.breadcrumbConfig()}
                                    finalTitle={formatText('fundsCard-title')}
                                    isNotMainTitle
                                >
                                </OKHeaderSubPage>
                            </div>
                            <div className="col-md-4 col-xs-12 container--paginator">
                                {
                                    fund &&
                                    <AssetsNavigator fund={fund} match={match} location={location}/>
                                }
                            </div>
                            {complexity && (
                                <div className="investment-fund-view__alert">
                                    <FormattedText value="fundsCard-alertComplexity_title" /><br/>
                                    <img src={comlexity_icon} alt="complexity icon" /> <FormattedText value="fundsCard-alertComplexity_content" />
                                </div>
                            )}
                        </OKCover>
                    </div>
                </div>
                {content}
            </div>
        );
    }
}


InvestmentFundsView.propTypes = {
    assetsCategory: PropTypes.string.isRequired,
    closeGlossary: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    isPublicUser: PropTypes.bool.isRequired,
    contextUriFundsLandingView: PropTypes.string,
    fetchFund: PropTypes.func.isRequired,
    fund: PropTypes.object,
    openGlossary: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    searchData: PropTypes.func.isRequired,
    user: PropTypes.object,
    minimumDetails: PropTypes.array,
    memoriesURL: PropTypes.string,
    onlyOneFundWithSameIsin: PropTypes.string.isRequired,
    catalogueDetails: PropTypes.object,
    immFeatureFlags: PropTypes.object.isRequired,
};

InvestmentFundsView.defaultProps = {
    contextUriFundsLandingView:'/myprofile/broker/funds',
    AssetsNavigator: MyFundsNavigator,
    UserFundBox: MyFundInfo,
    isPublicUser: false
}

const theOnlyOne = (brokerMyInvestments, routeParams) => {
    const stocks = brokerMyInvestments.getIn(['products', 'funds', 'stocks'])
    if(!stocks || stocks.size === 0) return ''

    const { id } = routeParams
    const filter = stocks.filter(stock => stock.get('isin') == id);
    const contractNumber = !!filter && filter.size === 1
        ? filter.getIn([0, "numerodecontrato"], '')
        : '';
    return contractNumber;
}

const mapStateToProps = (state, props) => ({
    fund: selectFund(state, props),
    onlyOneFundWithSameIsin: theOnlyOne(state.brokerMyInvestments, props.match.params),
    originCountry: state.profile.get('originCountry'),
    assetsCategory: state.brokerInvestmentFundView.assetsCategory,
    subCategories: state.brokerInvestmentFundView.subCategories,
    minimumDetails: state.brokerInvestmentFundView.minimumDetails,
    catalogueDetails: state.brokerInvestmentFundView.catalogueDetails,
    loading: state.brokerInvestmentFundView.loading,
    error: state.brokerInvestmentFundView.error,
    memoriesURL: state.globalVariables.getIn(['variables', 'parameters', 'memories', 'memories']),
    immFeatureFlags: state.flagBasedFeatures,
});

const mapDispatchToProps = dispatch => ({
    closeGlossary: () => dispatch(glossaryClosed()),
    fetchFund: ({idType, id, originCountry, isPublicUser}) => dispatch(fundFetchRequested({idType, id, originCountry, isPublicUser})),
    openGlossary: query => dispatch(glossaryOpened({ query })),
    searchData: (isin) => dispatch(searchDataWithIsin(isin)),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(InvestmentFundsView);
